// 超过指定长度字符显示省略号
export const lengthLimit = (field, num = 8) => {
    const isOmit = field.length <= num;
    return isOmit ? field : `${field.substring(0, num)}...`;
};
